<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header">
        <h5>Добавление ссылки для приоритетного сканирования</h5>
      </div>
      <div class="card-body">
        <form @submit.prevent="() => updateRecord()">
          <div class="row">
            <div class="col-md-2 form-group">
              <label for="">Проект</label>
              <select v-model="newRecord.project_id" class="form-control">
                <option v-for="p in $AllProjects" v-if="p.is_active" :value="p.id">{{ p.title }}</option>
              </select>
            </div>
            <!--            <div class="col-md-3 form-group">-->
            <!--              <label for="">Препарат</label>-->
            <!--              <DrugSearchNew :onSelect="(d) => newRecord.drug_id = d?.id"/>-->
            <!--            </div>-->
            <div class="col-md-5 form-group">
              <label for="">Линк</label>
              <input type="text" class="form-control" required v-model="newRecord.url">
            </div>
            <!--            <div class="col-md-2 form-group">-->
            <!--              <label for="">Блокировка</label>-->
            <!--              <input type="text" class="form-control" required v-model="newRecord.block_data">-->
            <!--            </div>-->
          </div>
          <div class="text-right">
            <LoadingButton
              title="Сохранить"
              :loading="loading.saveNew"
              type="submit"
              :color="$constants.SUCCESS_COLOR"
              :onClick="() => {}"
              className="btn btn-outline-success"
            />
          </div>
        </form>
      </div>
    </div>
    <div class="card" v-if="topPriorityRecords.length">
      <div class="card-header">
        <h5>Ссылки для приоритетного сканирования</h5>
      </div>
      <div class="card-body">
        <table class="table table-sm table-hover">
          <thead>
          <tr>
            <th></th>
            <th>Проект</th>
            <th>link</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(r, i) in topPriorityRecords">
            <td>{{ i + 1 }}</td>
            <td>{{ $AllProjects[r.project_id]?.title ?? r.project_id }}</td>
            <td><a target="_blank" :href="r.url">{{ r.url }}</a></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="card" v-if="loading.list || records">
      <div class="card-header">
        <h5>Ссылки в реестре РКН</h5>
      </div>
      <div class="card-body">
        <select @change="getRecords()" v-model="filter.project_id" class="form-control">
          <option value="0">Все проекты</option>
          <option v-for="p in $AllProjects" v-if="p.is_active" :value="p.id">{{ p.title }}</option>
        </select>
        <pulse-loader :loading="loading.list" :color="$constants.LOADING_COLOR" class="text-center"/>
        <template v-if="records">
          <hr>
          <table class="table mt-0 table-sm table-hover">
            <thead>
            <tr>
              <th></th>
              <th>ID</th>
              <th>Проект</th>
              <th>link</th>
              <th>статус</th>
              <th>блокировка</th>
              <th>дата обновления</th>
              <th>дата внесения</th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(r,i) in records">
              <td>{{ (i + 1) + ((paginator.current_page - 1) * paginator.per_page) }}</td>
              <td>{{ r.project_web_site?.drug_id }}</td>
              <td>{{
                  r.project_id ? $AllProjects[r.project_id]?.title ?? r.project_id : r.project_id
                }}
              </td>
              <td><a v-if="r.project_web_site?.url" :href="r.project_web_site.url"
                     target="_blank">{{ r.project_web_site.url }}</a></td>
              <td
                :class="{'font-weight-bold': isTextBold(r.issue_text), 'text-success': isTextBold(r.issue_text, 'no_issue')}">
                {{ r.issue_text }}
              </td>
              <td>{{ r.issue_code }}</td>
              <td>{{ printDate(r.updated_at, 'DD.MM.YYYY HH:mm') }}</td>
              <td>{{ printDate(r.created_at, 'DD.MM.YYYY HH:mm') }}</td>
              <td>
                <input type="checkbox" v-model="r.sub_status">
              </td>
              <td>
                <LoadingButton
                  v-if="getActivityTitle(r)"
                  :title='getActivityTitle(r)'
                  :loading="loading.updateActivity[r.id]"
                  type="button"
                  color="#4fc47f"
                  :onClick="() => updateRecordActivity(r)"
                  className="btn btn-outline-success btn-xs"
                />
              </td>
              <td>
                <input type="text" placeholder="комментарий" v-model="r.extra_data.comment" class="form-control">
              </td>
              <td>
                <LoadingButton
                  title='<i class="icon-fa icon-fa-save"></i>'
                  :loading="loading.updateRecord[r.id]"
                  type="button"
                  color="#4fc47f"
                  :onClick="() => updateRecord(r)"
                  className="btn btn-outline-success btn-xs"
                />
              </td>
            </tr>
            </tbody>
          </table>
          <div class="text-right">
            <paginate v-if="paginator"
                      v-model="paginator.current_page"
                      :page-count="paginator.last_page"
                      :page-range="3"
                      :margin-pages="2"
                      :click-handler="getRecords"
                      :prev-text="'&laquo'"
                      :next-text="'&raquo'"
                      :container-class="'pagination'"
                      :prev-class="'page-item'"
                      :prev-link-class="'page-link'"
                      :page-class="'page-item'"
                      :page-link-class="'page-link'"
                      :next-class="'page-item'"
                      :next-link-class="'page-link'"
                      :active-class="'active green_btn'">
            </paginate>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import Paginate from 'vuejs-paginate'
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import DrugSearchNew from "@/components/drugs/DrugSearchNew.vue";

export default {
  title: 'Блокировка ссылок',
  components: {
    DrugSearchNew,
    LoadingButton,
    Paginate,
  },
  data() {
    return {
      loading: {
        list: false,
        saveNew: false,
        updateRecord: {},
        updateActivity: {},
      },
      filter: {
        project_id: 0
      },
      newRecord: {url: '', block_data: '', project_id: 1, drug_id: null},
      paginator: null,
      records: null,
      topPriorityRecords: []
    }
  },
  computed: {
    $AllProjects() {
      const sites = this.$store.getters["platform/projects"].reduce(
        (acc, p) => {
          acc[p.id] = {...p};
          return acc;
        },
        {}
      );
      return sites;
    },
  },
  created() {
    this.getRecords();
  },
  methods: {
    isTextBold(text, alias = 'block') {
      switch (alias) {
        case 'block':
          return (text ?? '').includes('ограничивается');
        case 'no_issue':
          return (text ?? '').includes('ничего не найдено');
      }
      return false;
    },
    async updateRecordActivity(record) {
      this.loading.updateActivity[record.id] = true;
      this.loading = {...this.loading};
      const {data} = await api.post('/new/drugs/update', {
        drugId: record.project_web_site.drug_id,
        type: 'activityUpdate',
        project_id: record.project_web_site.project_id,
        new_value: !this.getActivityTitle(record, true)
      });
      if (data.success) {
        await this.getRecords(1, true);
        toastr['success']('Сохранено');
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loading.updateActivity[record.id] = false;
      this.loading = {...this.loading};
    },
    getActivityTitle(record, actualValue = false) {
      const projectPrice = (record?.project_web_site?.drug?.prices ?? []).find((p) => p.qty === 1 && p.site_id === record.project_web_site.project_id);
      if (!projectPrice) return false;
      return actualValue ? projectPrice?.is_active : (projectPrice?.is_active ? 'деактивировать' : 'активировать');
    },
    async updateRecord(record = null) {
      if (!record) {
        this.loading.saveNew = true;
      } else {
        this.loading.updateRecord[record.id] = true;
        this.loading = {...this.loading};
      }
      const {data} = await api.post('/projects/blocklinks/update', {
        record: record ? record : this.newRecord
      });
      if (data.success) {
        await this.getRecords(1, true);
        toastr['success']('Сохранено');
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      if (record) {
        this.loading.updateRecord[record.id] = false;
        this.loading = {...this.loading};
      }
      this.loading.saveNew = false;
    },
    async getRecords(page = 1, silent = false) {
      this.loading.list = !silent;
      const {data: r_data} = await api.post('/projects/blocklinks', {
        page,
        filter: this.filter
      });
      if (r_data.success) {
        const {data, ...pagination} = r_data.records;
        this.paginator = pagination;
        this.topPriorityRecords = r_data.topPriorityRecords;
        this.records = data.reduce((acc, r) => {
          if (!r.extra_data) r.extra_data = {};
          acc.push(r);
          return acc;
        }, []);
      } else {
        toastr['warning'](r_data.message || 'Ошибка');
      }
      this.loading.list = false;
    }
  }
}

</script>
